<template>
    <div class="col-lg-6 pt-5">
      <h2>{{words}}</h2>
      <section class="destination-wrapper" aria-label="Explore Alabama">
        <b-carousel
          controls
          indicators
          img-width="480"
          img-height="270"
          >
    <!-- Text slides with image -->
          <b-carousel-slide
          v-for="destination in destinations"
          :key="destination.id"
          :style="imageStyle(destination.imageUrl)">
          <router-link v-if="destination.slug" :to="'/places-to-go/cities-and-towns/'+destination.slug">
            <article class="carousel-wrapper">
                <div class="map-wrapper">
                  <CountyMap :Region="destination.region" :counties="destination.counties.map(c => c.toLowerCase())" :ScaleX=1 :ScaleY=1 :Rotate=-7 />
                </div>
                <div class="text-wrapper">
                  <h3>{{destination.name}}</h3>
                  <p v-html="truncateString(destination.title, 250)"></p>
              </div>
            </article>
          </router-link>
          <div v-else class="carousel-wrapper">
            <div class="map-wrapper">
              <CountyMap :Region="destination.region" :counties="destination.counties.map(c => c.toLowerCase())" :ScaleX=1 :ScaleY=1 :Rotate=-7 />
            </div>
            <div class="text-wrapper">
              <h3>{{destination.name}}</h3>
              <p v-html="truncateString(destination.title, 250)"></p>
            </div>
          </div>
          </b-carousel-slide>
        </b-carousel>
    </section>
    </div>
</template>

<script>
import CountyMap from '@/components/PlacesToGo/Common/CountyMap.vue';

export default {
  name: 'Destination',
  components: {
    CountyMap,
  },
  props: {
    destinations: {
      type: Array,
      required: true,
    },
    words: {
      type: String,
    },
    defaultImage: {
      type: String,
    },
  },
  methods: {
    imageStyle(imageUrl, defaultImage) {
      if (imageUrl) {
        return `background-image : url(${imageUrl})`;
      }
      return `background-image : url(${defaultImage})`;
    },
    truncateString(string, maxLength) {
      if (string.length > maxLength) {
        return `${string.slice(0, maxLength - 3)}...`;
      }
      return string;
    },
  },
};
</script>

<style scoped>

  a,
  h3 {
   color: #173945; }
.carousel {
  height:100%;
}
.carousel-item  {
  min-height: 400px;    /* Set slide height here */
  background-repeat: no-repeat!important;
  background-size: cover!important;
  background-position: center!important;
  width:100%!important;

}
.destination-wrapper >>> .carousel-inner {
  overflow-y: visible!important;
  min-height: 690px;
}
.destination-wrapper >>> .carousel-caption {
  padding-bottom: 170px!important;
  min-height:400px!important;
}
.destination-wrapper >>> .carousel-control-prev,
.destination-wrapper >>> .carousel-control-next {
  opacity: 1;
  margin-bottom: 350px;
  width: 55px;
}
.destination-wrapper >>> .carousel-control-next {
  right: -65px;
}
.destination-wrapper >>> .carousel-control-prev {
  left: -60px;
}
.destination-wrapper >>> .carousel-control-next-icon,
.destination-wrapper >>> .carousel-control-prev-icon {
  background-image: none;
}

.destination-wrapper >>> a.carousel-control-prev,
.destination-wrapper >>> a.carousel-control-next {
  z-index: 99;
  color: #ccc;
  background-image: none;
}

.destination-wrapper >>> a:hover.carousel-control-prev,
.destination-wrapper >>> a:active.carousel-control-prev,
.destination-wrapper >>> a:hover.carousel-control-next,
.destination-wrapper >>> a:active.carousel-control-next {
  color: #357e99;
}

.destination-wrapper >>> .carousel-control-prev-icon:before {
  font-family: 'icomoon';
  content: "\e902";
  font-size: 4.5rem;
}
.destination-wrapper >>> .carousel-control-next-icon:before {
  font-family: 'icomoon';
  content: "\e903";
  font-size: 4.5rem;
}

.carousel-control-prev:hover,
.carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color:#ccc;
  opacity: 1;
}

.destination-wrapper {
  padding:20px 80px;
}
.destination-wrapper >>> .carousel-caption {
    position: absolute;
    right: 0px;
    left: 0px;
    top:0px;
    bottom:0px;
    z-index: 10;
    padding-top: 0px;
    padding-bottom: 0px;
    color: #173945;
    text-align: left;
}
.destination-wrapper >>> .carousel-caption h1 {
    font-size:2.5rem;
    line-height:2.5rem;
}
.destination-wrapper >>> .carousel-caption .carousel-wrapper {
  position: absolute;
    right: 0;
    top:420px;
    left: 0;
    min-height:135px;
}

.destination-wrapper >>> .carousel-caption .map-wrapper {
  width:100px;
  float:left;
  top:0px;
  position: absolute;
}

.destination-wrapper >>> .carousel-caption .text-wrapper {
  float:left;
  position: relative;
  margin-left: 100px;
}

.destination-wrapper >>> .carousel-caption .text-wrapper p {
  font-family: 'IdealSans-Book';
  font-size:18px;
}

.destination-wrapper >>> .carousel-caption .description {
  margin-left:0px;
  float:none;
}

.destination-wrapper >>> .carousel-item {
  position:relative;
}

.destination-wrapper >>> .carousel-item img {
  padding-bottom:170px;
}

/* .destination-wrapper >>> .carousel-indicators {
    position: absolute;
    right: 0;
    bottom:258px;
    left: 0;
    z-index: 15;
    justify-content: flex-end;
    padding-left: 0;
     margin-right: 0;
    margin-left: 0;
    list-style: none;
}
.destination-wrapper >>> .carousel-indicators li {

    background-color: #fff;
    border: 1px solid #4e97b2;
    margin-left:1px;
    margin-right:1px;
} */
a:hover + .carousel-wrapper > .text-wrapper, a:focus + .carousel-wrapper > .text-wrapper {
  text-decoration: underline!important;
}
/* .destination-wrapper >>> .carousel-indicators .active {
    opacity: 1;
    background-color: #4e97b2;
} */

@media only screen and (max-width: 1024px) {
  .destination-wrapper {
    padding:20px 40px;
  }

  .destination-wrapper >>> .carousel-control-next {
    right:-55px;
  }

  .destination-wrapper >>> .carousel-control-prev {
    left:-50px;
  }
}

@media only screen and (max-width: 768px) {
  .destination-wrapper {
    padding:20px 35px;
  }

  .destination-wrapper >>> .carousel-caption .text-wrapper {
    margin-left: 80px;
  }

  .destination-wrapper >>> .carousel-caption .map-wrapper {
    width: 60px;
  }
  .destination-wrapper >>> .carousel-control-next-icon:before {
    content: "\e903";
    font-family: 'icomoon';
    font-size: 2.5rem;
  }

  .destination-wrapper >>> .carousel-control-prev-icon:before {
    content: "\e902";
    font-family: 'icomoon';
    font-size: 2.5rem;
  }

  .destination-wrapper >>> .carousel-item img {
    padding-bottom:210px;
  }
/*
  .destination-wrapper >>> .carousel-indicators {
      bottom:260px;
  } */

  .destination-wrapper >>> .carousel-control-prev,
  .destination-wrapper >>> .carousel-control-next {
    margin-bottom:250px;
    width:30px;
  }

  .destination-wrapper >>> .carousel-control-next {
    right:-35px;
  }

  .destination-wrapper >>> .carousel-control-prev {
    left:-35px;
  }
}

.destination-wrapper >>> .carousel-control-prev:focus,
.destination-wrapper >>> .carousel-control-next:focus {
  outline: 2px solid;
  outline-color: #d86f48;
  outline-offset: .15em;
}
</style>
